<template>
    <base-section
    id="all-news"
    >
    <v-container>
        <base-section-heading
        title="News"
        color="red"
        align="left"
        :toColor="true"
        >
        </base-section-heading>

      <!-- News List -->
      <v-row>
        <v-col cols="12" md="8">
          <v-card flat>
            <v-list>
              <template v-for="(news, index) in allNews">
                <!-- News Item -->
                <v-list-item
                  :key="news.link"
                  :to="news.link"
                  link
                >
                  <v-list-item-content>
                    <v-list-item-subtitle class="text-caption primary--text mb-1">
                      {{ news.date }}
                    </v-list-item-subtitle>
                    <v-list-item-text class="text-body-1">
                      {{ news.text }}
                    </v-list-item-text>
                  </v-list-item-content>

                  <v-list-item-action>
                    <v-icon small>mdi-chevron-right</v-icon>
                  </v-list-item-action>
                </v-list-item>

                <!-- Divider (except for last item) -->
                <v-divider
                  v-if="index < allNews.length - 1"
                  :key="`divider-${index}`"
                ></v-divider>
              </template>
            </v-list>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    </base-section>
  </template>

  <script>
  export default {
    name: 'News',
    data: () => ({
      allNews: [
      {
        date: 'February 25, 2026',
        text: 'Technical program is out.',
        link: '/program',
      },
      {
        date: 'February 18, 2026',
        text: 'Keynotes and embedded tutorials are now available.',
        link: '/program/keynotes',
      },
      {
        date: 'December 25, 2025',
        text: 'Registrations instructions are available.',
        link: '/registration',
      },
      {
        date: 'December 25, 2025',
        text: 'McCluskey details are out!',
        link: '/mc-cluskey',
      },
        // Add more news items here
      ],
    }),
  }
  </script>

  <style scoped>
  /* Optional: Add hover effect for news items */
  :deep(.v-list-item:hover) {
    background-color: rgba(0, 0, 0, 0.04);
  }

  /* Optional: Add some spacing between news items */
  :deep(.v-list-item) {
    padding: 16px 0;
  }
  </style>